"use client";

import { c as _c } from "react/compiler-runtime";
import { AI } from "remotestorage-module-ai-wallet";
import { useEffect, Suspense, useRef } from "react";
import { format } from "date-fns";
import { useRemoteStorage } from "@/hooks/use-remote-storage";
import { sortTodos } from "@/lib/utils/todo";

// Feature components
import { TodoHeader, TodoInputBar } from "./components";
import { TodoSkeleton } from "./TodoSkeleton";
import { TodoList } from "./TodoList";
import { EmptyState } from "./EmptyState";
import { LoadingState } from "./LoadingState";
import { Sidebar } from "./Sidebar";
import { ArchiveView } from "./ArchiveView";

// Feature hooks
import { useClientHydration } from "./hooks";

// Stores
import { useTodoStore, type ViewMode } from "@/stores/use-todo-store";
import { useUIStore } from "@/stores/use-ui-store";
export default function Todo() {
  const $ = _c(69);
  const inputRef = useRef(null);
  const isClientLoaded = useClientHydration();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      modules: [AI],
      accessClaims: {
        "ai-wallet": "rw",
        "todonna": "rw",
        "logs": "rw"
      },
      apiKeys: {
        googledrive: ""
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const remoteStorage = useRemoteStorage(t0);
  const todos = useTodoStore(_temp);
  const selectedDate = useTodoStore(_temp2);
  const sortBy = useTodoStore(_temp3);
  const viewMode = useTodoStore(_temp4);
  const setSelectedDate = useTodoStore(_temp5);
  const setViewMode = useTodoStore(_temp6);
  const setRemoteStorage = useTodoStore(_temp7);
  const setApiKey = useTodoStore(_temp8);
  const apiKey = useTodoStore(_temp9);
  const handleAction = useTodoStore(_temp10);
  const toggleTodo = useTodoStore(_temp11);
  const deleteTodo = useTodoStore(_temp12);
  const unarchiveTodo = useTodoStore(_temp13);
  const getArchivedTodos = useTodoStore(_temp14);
  const isLoadingTodonna = useUIStore(_temp15);
  const isLoading = useUIStore(_temp16);
  const startEditing = useUIStore(_temp17);
  const cancelEditing = useUIStore(_temp18);
  let t1;
  let t2;
  if ($[1] !== remoteStorage || $[2] !== setRemoteStorage) {
    t1 = () => {
      if (remoteStorage) {
        setRemoteStorage(remoteStorage);
      }
    };
    t2 = [remoteStorage, setRemoteStorage];
    $[1] = remoteStorage;
    $[2] = setRemoteStorage;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== remoteStorage || $[6] !== setApiKey) {
    t3 = () => {
      (remoteStorage as any)?.aiWallet.getConfig().then(config => {
        console.log({
          config
        });
        if (config && config.apiKey) {
          setApiKey(config.apiKey);
        }
      }).catch(_temp19);
    };
    t4 = [remoteStorage, setApiKey];
    $[5] = remoteStorage;
    $[6] = setApiKey;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== isClientLoaded || $[10] !== selectedDate || $[11] !== sortBy || $[12] !== todos || $[13] !== viewMode) {
    const filteredTodos = isClientLoaded ? todos.filter(todo => {
      const todoDate = new Date(todo.date);
      const dateMatches = todoDate.toDateString() === selectedDate.toDateString();
      if (viewMode === "archive") {
        return dateMatches && todo.removed === true;
      }
      return dateMatches && !todo.removed;
    }) : [];
    t5 = isClientLoaded ? sortTodos(filteredTodos, sortBy) : [];
    $[9] = isClientLoaded;
    $[10] = selectedDate;
    $[11] = sortBy;
    $[12] = todos;
    $[13] = viewMode;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const sortedTodos = t5;
  let t6;
  if ($[15] !== todos) {
    t6 = new Set(todos.filter(_temp20).map(_temp21));
    $[15] = todos;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const datesWithTodos = t6;
  let t7;
  if ($[17] !== handleAction) {
    t7 = (text, emoji) => {
      handleAction(text, emoji);
    };
    $[17] = handleAction;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleActionWithEmoji = t7;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      inputRef.current?.focus();
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const focusInput = t8;
  let t9;
  if ($[20] !== cancelEditing) {
    t9 = updatedTodo => {
      const updateTodo = useTodoStore.getState().updateTodo;
      if (updatedTodo.text.trim()) {
        updateTodo(updatedTodo);
      }
      cancelEditing();
    };
    $[20] = cancelEditing;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const handleEditTodo = t9;
  let t10;
  if ($[22] !== startEditing || $[23] !== todos) {
    t10 = (id, text_0, emoji_0) => {
      const todo_2 = todos.find(t => t.id === id);
      startEditing(id, text_0, emoji_0 || "", todo_2?.time || "");
    };
    $[22] = startEditing;
    $[23] = todos;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const handleStartEditing = t10;
  let t11;
  if ($[25] !== setViewMode) {
    t11 = mode => {
      setViewMode(mode);
    };
    $[25] = setViewMode;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const handleViewModeChange = t11;
  let t12;
  if ($[27] !== setSelectedDate) {
    t12 = date => {
      setSelectedDate(date);
    };
    $[27] = setSelectedDate;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const handleDateChange = t12;
  let t13;
  if ($[29] !== unarchiveTodo) {
    t13 = id_0 => {
      unarchiveTodo(id_0).catch(_temp22);
    };
    $[29] = unarchiveTodo;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const handleUnarchive = t13;
  const isSidebarCollapsed = useUIStore(_temp23);
  const toggleSidebar = useUIStore(_temp24);
  let t14;
  if ($[31] !== handleViewModeChange || $[32] !== isSidebarCollapsed || $[33] !== toggleSidebar || $[34] !== viewMode) {
    t14 = <Sidebar viewMode={viewMode} onViewModeChange={handleViewModeChange} isCollapsed={isSidebarCollapsed} onToggleCollapse={toggleSidebar} />;
    $[31] = handleViewModeChange;
    $[32] = isSidebarCollapsed;
    $[33] = toggleSidebar;
    $[34] = viewMode;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== datesWithTodos || $[37] !== handleDateChange || $[38] !== selectedDate || $[39] !== todos) {
    t15 = <TodoHeader selectedDate={selectedDate} todos={todos} datesWithTodos={datesWithTodos} onDateChange={handleDateChange} />;
    $[36] = datesWithTodos;
    $[37] = handleDateChange;
    $[38] = selectedDate;
    $[39] = todos;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TodoSkeleton />;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== cancelEditing || $[43] !== deleteTodo || $[44] !== getArchivedTodos || $[45] !== handleEditTodo || $[46] !== handleStartEditing || $[47] !== handleUnarchive || $[48] !== isClientLoaded || $[49] !== isLoading || $[50] !== isLoadingTodonna || $[51] !== selectedDate || $[52] !== sortBy || $[53] !== sortedTodos || $[54] !== toggleTodo || $[55] !== viewMode) {
    t17 = <div className="-mx-4"><Suspense fallback={t16}>{!isClientLoaded || isLoadingTodonna ? <LoadingState /> : viewMode === "archive" ? <ArchiveView todos={getArchivedTodos()} sortBy={sortBy} selectedDate={selectedDate} onToggle={toggleTodo} onDelete={deleteTodo} onUnarchive={handleUnarchive} onEdit={handleStartEditing} handleEditTodo={handleEditTodo} cancelEditing={cancelEditing} /> : sortedTodos.length === 0 && isLoading ? <LoadingState /> : sortedTodos.length === 0 && !isLoading ? <EmptyState selectedDate={selectedDate} focusInput={focusInput} /> : <TodoList todos={sortedTodos} onToggle={toggleTodo} onDelete={deleteTodo} onEdit={handleStartEditing} handleEditTodo={handleEditTodo} cancelEditing={cancelEditing} />}</Suspense></div>;
    $[42] = cancelEditing;
    $[43] = deleteTodo;
    $[44] = getArchivedTodos;
    $[45] = handleEditTodo;
    $[46] = handleStartEditing;
    $[47] = handleUnarchive;
    $[48] = isClientLoaded;
    $[49] = isLoading;
    $[50] = isLoadingTodonna;
    $[51] = selectedDate;
    $[52] = sortBy;
    $[53] = sortedTodos;
    $[54] = toggleTodo;
    $[55] = viewMode;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== apiKey || $[58] !== handleActionWithEmoji || $[59] !== isLoading || $[60] !== viewMode) {
    t18 = viewMode === "daily" && <TodoInputBar isLoading={isLoading} apiKey={apiKey} onAction={handleActionWithEmoji} inputRef={inputRef} />;
    $[57] = apiKey;
    $[58] = handleActionWithEmoji;
    $[59] = isLoading;
    $[60] = viewMode;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== t15 || $[63] !== t17 || $[64] !== t18) {
    t19 = <div className="flex-1 max-w-md w-full mx-auto p-4 space-y-4 pb-24 flex flex-col">{t15}{t17}{t18}</div>;
    $[62] = t15;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== t14 || $[67] !== t19) {
    t20 = <div className="flex h-full">{t14}{t19}</div>;
    $[66] = t14;
    $[67] = t19;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  return t20;
}
function _temp24(state_18) {
  return state_18.toggleSidebar;
}
function _temp23(state_17) {
  return state_17.isSidebarCollapsed;
}
function _temp22(error_0) {
  console.error("Failed to unarchive todo:", error_0);
}
function _temp21(todo_1) {
  return format(new Date(todo_1.date), "yyyy-MM-dd");
}
function _temp20(todo_0) {
  return !todo_0.removed;
}
function _temp19(error) {
  console.error("Failed to fetch API key from RemoteStorage:", error);
}
function _temp18(state_16) {
  return state_16.cancelEditing;
}
function _temp17(state_15) {
  return state_15.startEditing;
}
function _temp16(state_14) {
  return state_14.isLoading;
}
function _temp15(state_13) {
  return state_13.isLoadingTodonna;
}
function _temp14(state_12) {
  return state_12.getArchivedTodos;
}
function _temp13(state_11) {
  return state_11.unarchiveTodo;
}
function _temp12(state_10) {
  return state_10.deleteTodo;
}
function _temp11(state_9) {
  return state_9.toggleTodo;
}
function _temp10(state_8) {
  return state_8.handleAction;
}
function _temp9(state_7) {
  return state_7.apiKey;
}
function _temp8(state_6) {
  return state_6.setApiKey;
}
function _temp7(state_5) {
  return state_5.setRemoteStorage;
}
function _temp6(state_4) {
  return state_4.setViewMode;
}
function _temp5(state_3) {
  return state_3.setSelectedDate;
}
function _temp4(state_2) {
  return state_2.viewMode;
}
function _temp3(state_1) {
  return state_1.sortBy;
}
function _temp2(state_0) {
  return state_0.selectedDate;
}
function _temp(state) {
  return state.todos;
}